export const CatalogTag = ({
  title,
  highlighted,
  onClick,
  style = {},
}: any) => {
  return (
    <span
      onClick={onClick}
      data-cy={`catalog-tag-${title.toLowerCase()}`}
      data-highlighted={highlighted}
      style={{
        border: '1px solid rgba(48,131,220,1)',
        borderRadius: '9999px',
        padding: '2px 10px',
        fontSize: 12,
        marginRight: 6,
        ...style,
        background: highlighted ? 'rgba(48,131,220,1)' : style.background,
        color: highlighted ? '#fff' : style.color,
      }}
    >
      {title}
    </span>
  );
};
